import { render, staticRenderFns } from "./set-proxy.vue?vue&type=template&id=0a56677f&"
import script from "./set-proxy.vue?vue&type=script&lang=js&"
export * from "./set-proxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports